import { render, staticRenderFns } from "./UserBalanceBalances.vue?vue&type=template&id=35bcb0bb&scoped=true&"
import script from "./UserBalanceBalances.vue?vue&type=script&lang=js&"
export * from "./UserBalanceBalances.vue?vue&type=script&lang=js&"
import style0 from "./UserBalanceBalances.vue?vue&type=style&index=0&id=35bcb0bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bcb0bb",
  null
  
)

export default component.exports